module.exports = __webpack_public_path__ + "static/hdw-f53b8ba125cb5869335693fe97eacc93.svg";